import React, { Component } from "react";
// react-accessible-accordion: Accessible Accordion component
import {
    AccordionItem,
    AccordionItemHeading,
    AccordionItemPanel,
    AccordionItemButton,
    AccordionItemState
} from "react-accessible-accordion";
import SubCategoryItem from "./SubCategoryItem";


/**************************************************************/
//          CategoryItemComponent
/**************************************************************/

class CategoryItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAccordionExpanded: false
        };
    }

    handleAccordionStateChange = (expanded) => {
        if (this.state.isAccordionExpanded !== expanded) {
            this.setState({ isAccordionExpanded: expanded });
        }
    };
    // No local state or manual expand/collapse logic

    handleCategoryLinkClick = () => {
        this.props.closeAccordion([]);
    };

    /**
     * responsible for creating the subcategories that act as links
     *  */
    createSubcategories(parentCategory, categories) {
        if (categories !== undefined) {
            let renderedSubcategory = categories.map(
                function (subcat, i) {
                    return (
                        <SubCategoryItem
                            key={i}
                            fitmentErrorActive={this.props.fitmentErrorActive}
                            closeAccordion={this.props.closeAccordion}
                            selectCategory={this.props.selectCategory}
                            currentCategory={this.props.currentCategory}
                            category={subcat}
                            searchParams={this.props.searchParams}
                            handleURL={this.props.handleURL}
                        />
                    );
                }.bind(this)
            );

            return (
                <div className="accordion__body">
                    <ul id="ac-subcat-items" className="ac-subcat-items">
                        {renderedSubcategory}
                    </ul>
                </div>
            );
        } else {
            return (
                <ul id="ac-subcat-items" className="ac-subcat-items">
                    <li>...</li>
                </ul>
            );
        }
    }
    /**
     * renders the catnav bar
     * handleClick on <div> handles the category click
     * handleClick on <AccordionItemBody> handles the subcategory click*/
    render() {
        const { category, uuid } = this.props;
        const subCategoryItems = this.createSubcategories(category, category.subCategories);
        const categoryLabel = category.label;
        return (
            <AccordionItem
                uuid={uuid}
                className={"q-expander " + (this.state.isAccordionExpanded ? "q-button-active" : "")}
            >
                <AccordionItemState>
                    {({ expanded }) => {
                        this.handleAccordionStateChange(expanded);
                        return null;
                    }}
                </AccordionItemState>
                <AccordionItemHeading
                    className="ac-accordion-title q-headline q-expander-button stat-text-link"
                    data-dtm={"shop by category"}
                    onClick={(e) => {
                        e.stopPropagation();
                        this.handleCategoryLinkClick();
                    }}
                >
                    <AccordionItemButton
                        className="ac-category-link stat-text-link"
                        data-dtm={"shop by category: " + categoryLabel}
                    >
                        <h5>
                            <span data-dtm={"shop by category: " + categoryLabel}>
                                {categoryLabel} ({category.count})
                            </span>
                        </h5>
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>{subCategoryItems}</AccordionItemPanel>
            </AccordionItem>
        );
    }
}

export default CategoryItem;
